import { ALL_CMS_NAV_ITEMS } from 'features/index';
/** Single source for CMS sub-routes, shell nav, and host top bar order (first = default `/cms` redirect). */
export const CMS_FEATURES = ALL_CMS_NAV_ITEMS;
